<mat-toolbar id="searchBar">
  <div class="searchInput">
    <mat-form-field class="full-width">
      <mat-label>Recherche</mat-label>
      <input matInput [(ngModel)]="selectedFilter" (keyup)="filterChanged()">
    </mat-form-field>
  </div>
  <div class="extraInput">
    <section>
      <mat-checkbox labelPosition="after" [(ngModel)]="activeUser" (click)="filterChanged()">
        Actif
      </mat-checkbox>
      <mat-checkbox labelPosition="after" [(ngModel)]="inactiveUser" (click)="filterChanged()">
        Inactif
      </mat-checkbox>
    </section>
    <section class="mr-l-10">
      <button mat-flat-button color="primary" (click)="openUserCreationDialog()">Créer un utilisateur</button>
    </section>
  </div>
</mat-toolbar>
<table mat-table matSort [dataSource]="dataSource">
  <ng-container matColumnDef="name">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Nom</th>
    <td mat-cell *matCellDef="let element">
      @if (element?.parentId !== '') {
        <mat-icon class="table-icon green" title="ParentId défini">star</mat-icon>
      } @else {
        <mat-icon class="table-icon red" title="Pas de parentId défini">star</mat-icon>
      }
      {{element?.name}}
    </td>
  </ng-container>
  <ng-container matColumnDef="login">
    <th mat-header-cell *matHeaderCellDef>Login</th>
    <td mat-cell *matCellDef="let element">
      {{element?.login}}
    </td>
  </ng-container>
  <ng-container matColumnDef="nihii">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Inami</th>
    <td mat-cell *matCellDef="let element">
      <span class="inline-flex items-center gap-2">
        {{ element?.nihii }}
        <ms-license-override-tag
          [overrideType]="licenseService.getNihiiOverrideType(element?.nihii ?? '')"
        ></ms-license-override-tag>
      </span>
    </td>
  </ng-container>
  <ng-container matColumnDef="speciality">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Spécialité</th>
    <td mat-cell *matCellDef="let element">{{element?.speciality}}</td>
  </ng-container>
  <ng-container matColumnDef="ssin">
    <th mat-header-cell *matHeaderCellDef>Niss</th>
    <td mat-cell *matCellDef="let element">{{element?.ssin}}</td>
  </ng-container>
  <ng-container matColumnDef="street">
    <th mat-header-cell *matHeaderCellDef>Rue</th>
    <td mat-cell *matCellDef="let element">{{element?.adr?.street}} {{element?.adr?.houseNumber}}</td>
  </ng-container>
  <ng-container matColumnDef="postalCode">
    <th mat-header-cell *matHeaderCellDef>Code postal</th>
    <td mat-cell *matCellDef="let element">{{element.adr?.postalCode}}</td>
  </ng-container>
  <ng-container matColumnDef="city">
    <th mat-header-cell *matHeaderCellDef>Ville</th>
    <td mat-cell *matCellDef="let element">{{element.adr?.city}}</td>
  </ng-container>
  <ng-container matColumnDef="country">
    <th mat-header-cell *matHeaderCellDef>Pays</th>
    <td mat-cell *matCellDef="let element">{{element.adr?.country}}</td>
  </ng-container>
  <ng-container matColumnDef="region">
    <th mat-header-cell *matHeaderCellDef>Region</th>
    <td mat-cell *matCellDef="let element">{{ element.adr?.region }}</td>
  </ng-container>
  <ng-container matColumnDef="language">
    <th mat-header-cell *matHeaderCellDef>Langue</th>
    <td mat-cell *matCellDef="let element">{{ element.language }}</td>
  </ng-container>
  <ng-container matColumnDef="steps">
    <th mat-header-cell *matHeaderCellDef>Etapes</th>
    <td mat-cell *matCellDef="let element">
      <div class="steps">
        <div id="step_1" title="Définition du mdp">
          @if (element?.steps?.step_1 === true) {
            <mat-icon class="table-icon green">check_circle</mat-icon>
          } @else {
            <mat-icon class="table-icon red">cancel</mat-icon>
          }
        </div>
        <div id="step_2" title="Données du hcp">
          @if (element?.steps?.step_2 === true) {
            <mat-icon class="table-icon green">check_circle</mat-icon>
          } @else {
            <mat-icon class="table-icon red">cancel</mat-icon>
          }
        </div>
        <div id="step_3" title="Adresse">
          @if (element?.steps?.step_3 === true) {
            <mat-icon class="table-icon green">check_circle</mat-icon>
          } @else {
            <mat-icon class="table-icon red">cancel</mat-icon>
          }
        </div>
        <div id="step_4" title="Données de facturation">
          @if (element?.steps?.step_4 === true) {
            <mat-icon class="table-icon green">check_circle</mat-icon>
          } @else {
            <mat-icon class="table-icon red">cancel</mat-icon>
          }
        </div>
        <div id="step_5" title="Génération de la clé">
          @if (element?.steps?.step_5 === true) {
            <mat-icon class="table-icon green">check_circle</mat-icon>
          } @else {
            <mat-icon class="table-icon red">cancel</mat-icon>
          }
        </div>
      </div>
    </td>
  </ng-container>
  <ng-container matColumnDef="statusHr">
    <th mat-header-cell *matHeaderCellDef>Statut</th>
    <td mat-cell *matCellDef="let element">{{element?.statusHr}}</td>
  </ng-container>
  <ng-container matColumnDef="freeStatusHr">
    <th mat-header-cell *matHeaderCellDef>Statut</th>
    <td mat-cell *matCellDef="let element">{{element?.freeStatusHr}}</td>
  </ng-container>
  <ng-container matColumnDef="token">
    <th
      mat-header-cell
      *matHeaderCellDef
    >Token</th>
    <td
      mat-cell
      *matCellDef="let element"
    >
      <button
        mat-icon-button
        title="Copier un token temporaire"
        (click)="getTemporaryToken(groupInfos?.id ?? '', element?.userId)"
      >
        <mat-icon class="green">lock</mat-icon>
      </button>
    </td>
  </ng-container>
  <ng-container matColumnDef="email">
    <th mat-header-cell *matHeaderCellDef>Email</th>
    <td mat-cell *matCellDef="let element">{{element?.email}}</td>
  </ng-container>
  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
</table>
